import React from 'react';

import { Job } from '@libs/graphql-types';

import { BayerWorkerPayType } from './BayerWorkerPayType';
import { DefaultWorkerPayType } from './DefaultWorkerPayType';

interface WorkerPayTypeProps {
  job: Job;
  showOnlyRequired?: boolean;
}

/**
 * Component that renders different Worker Pay Type forms based on job source
 * Currently supports:
 * - Bayer: Custom worker pay type form for Bayer jobs
 * - Default: Standard worker pay type form for all other job sources
 */
export const WorkerPayType: React.FC<WorkerPayTypeProps> = ({
  job,
  showOnlyRequired = false,
}) => {
  const jobSource = job?.striive_job?.source;

  switch (jobSource) {
    case 'Bayer':
      return (
        <BayerWorkerPayType job={job} showOnlyRequired={showOnlyRequired} />
      );
    case 'HeadFirst':
    default:
      return (
        <DefaultWorkerPayType job={job} showOnlyRequired={showOnlyRequired} />
      );
  }
};
